import Phaser from 'phaser';

import { makeCharacterTextures } from '../render/sprites.js';

export class BootScene extends Phaser.Scene {
  constructor() { super('boot'); }

  create(): void {
    makeCharacterTextures(this);
    this.scene.start('game', this.registry.get('start'));
  }
}
